module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/362.14772031.png";